<template>
  <button @click="handleClick" class="close"></button>
</template>

<script>
export default {
  name: "CloseButton",

  methods: {
    handleClick() {
      this.$emit("click");
    }
  }
};
</script>

<style lang="scss" scoped>
$size: 34px;

.close {
  position: relative;
  width: $size;
  height: $size;
  padding: 0;
  overflow: hidden;
  background-color: transparent;

  &:hover {
    &::after,
    &::before {
      background-color: rgba(#ffffff, 0.5);
    }
  }

  &:active {
    &::after,
    &::before {
      background-color: rgba(#ffffff, 1);
      width: 100%;
    }
  }

  &::after,
  &::before {
    content: "";
    position: absolute;
    width: 150%;
    height: 2px;
    top: 50%;
    left: 50%;
    background-color: #ffffff;
    transition: all 0.25s ease;
  }

  &::after {
    transform: translate(-50%, -50%) rotate(45deg);
  }

  &::before {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
}
</style>
